function productsCategoriesSlider() {
  const sliders = document.querySelectorAll(".product-categories .splide");

  if (!sliders.length) return;

  sliders.forEach(el => {
    // Prevent double initialization
    if (el.dataset.splideInitialized === "true") return;

    const options = {
      type: "slide",
      autoWidth: false,
      perPage: 2,
      perMove: 2,
      gap: 10,
      mediaQuery: "min",
      pagination: false,
      speed: 500,
      keyboard: true,
      breakpoints: {
        768: {
          gap: 16,
          perPage: 5,
          perMove: 1
        }
      }
    };

    try {
      new Splide(el, options).mount();
      el.dataset.splideInitialized = "true";
    } catch (e) {
      // Fail gracefully without breaking the rest of the page
      console.error("[product-categories] Failed to initialize Splide:", e);
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  productsCategoriesSlider();
});
